import styled, { keyframes } from 'styled-components';

const runningAnimation = keyframes`
  0% {
    background-color: rgba(255, 255, 255, 0.1);
  }
  50% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  100% {
    background-color: rgba(255, 255, 255, 0.1);
  }
`;

export const Wrapper = styled.div`
  padding: 5px 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  box-sizing: border-box;

  &:nth-child(even) {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &.running {
    animation: ${runningAnimation} 1.4s infinite ease-in-out;
    font-weight: 600;

    .prompt {
      color: gold;
    }
  }

  &.archived {
    height: 0;
    opacity: 0;
    padding: 0;
  }
`;

export const Prompt = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: rgba(255, 255, 255, 0.8);
  flex: 1;
  font-size: 14px;
`;

export const Icon = styled.div``;

export const Extra = styled.div`
  width: 20px;
`;

export const Status = styled.div``;

export const Running = styled.div`
  position: relative;
  top: 4px;
`;
